module.exports = __webpack_public_path__ + "img/组-59.8e62743d.png";